import React from 'react'

function IconRight({ className }) {
    return (
        <svg className={className} width={24} height={22} viewBox='0 0 24 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M0 10H20.4167L11.6667 1.25L12.7667 0L23.6 10.8333L12.7667 21.6667L11.6667 20.4167L20.4167 11.6667H0L0 10Z'
                fill='white'
            />
        </svg>
    )
}

export default IconRight
